import Tabs from "../../../../src/pages/documentation/adobe-analytics/tabs/api-reference.md";
import Alerts from '/src/pages/documentation/resources/alerts.md';
import * as React from 'react';
export default {
  Tabs,
  Alerts,
  React
};